import { z } from "zod";

export const productEligibilityDocSchema = z.object({
    id: z.string(),
    productType: z
        .object({
            eligibleForWindowDecoration: z.boolean().nullish(),
            eligibleForSunProtection: z.boolean().nullish(),
        })
        .nullish(),
});

export const productEligibilityResponseSchema = z.object({
    Products: z.object({
        docs: z.array(productEligibilityDocSchema),
    }),
});
